import { makeStyles } from 'tss-react/mui';

const LINK = {
  alignItems: 'center',
  color: '#666',
  display: 'flex',
  gap: '12px',
  height: 40,
  textDecoration: 'none',
  padding: '0 11px',
  transition: 'all 0.3s ease-in-out',
  width: '100%',
  cursor: 'pointer',
  borderRadius: '0.5rem',
  border: '1px solid transparent',
  '&:hover': { backgroundColor: '#00000008' },
  '& svg': {
    width: '20px',
    height: '20px',
  },
};

const SIDEBAR = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  paddingBottom: 24,
  marginTop: 16,
  transition: 'gap 0.3s ease-in-out',
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    width: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '2px',
  },
  scrollbarGutter: 'stable',
};

export const useSidebarStyles = makeStyles()(() => ({
  sidebar: SIDEBAR,
  sidebarCollapsed: {
    ...SIDEBAR,
    gap: 0,
    '& span': { opacity: 0 },
  },
  link: LINK,
  linkActive: {
    ...LINK,
    pointerEvents: 'none',
    backgroundColor: '#e1e3f0',
    border: '1px solid #6a7ff4',
  },
  text: {
    color: '#000',
    transition: 'opacity 0.3s ease-in-out',
  },
  listItem: { padding: '0 12px' },
  list: { padding: 0, margin: 0 },
  appVersion: {
    position: 'absolute',
    marginLeft: '1.5rem',
    fontSize: '0.75rem',
    fontStyle: 'italic',
    bottom: '0.5rem',
  },
  tooltipPopper: {
    zIndex: 3200,
  },
}));
